import { cx } from '@linaria/core';
import { resets } from '@ui/css';
import { PencilIcon } from '../../icons/pencil.js';
import { input, pencil, inputWrapper } from './edit-input.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function EditInput({
  value,
  mode,
  onChange,
  ...props
}) {
  const handleChange = evt => {
    onChange(evt.target.value);
  };
  const onKeyDown = evt => {
    if (value && evt.key === "Escape") {
      evt.stopPropagation();
      onChange("");
    }
  };
  return /*#__PURE__*/jsxs("div", {
    className: cx(resets.rootCls, props.className, inputWrapper),
    "data-mode": mode,
    children: [/*#__PURE__*/jsx("input", {
      ...props,
      value: value,
      onChange: handleChange,
      onKeyDown: onKeyDown,
      className: input
    }), /*#__PURE__*/jsx(PencilIcon, {
      className: pencil
    })]
  });
}

export { EditInput };
//# sourceMappingURL=edit-input.js.map
